import './SubscriptionHero.scss';

// Desktop: Figma 6128-17948. Mobile: 6180-7570 — replace hero-bags-mobile.png when exported.
import heroBagsDesktop from '../../../images/hero-bags-desktop.png';
import heroBagsMobile from '../../../images/hero-bags-mobile.png';
import heroUnlimitedIcon from '../../../images/hero-unlimited-icon.svg';

const SubscriptionHero = () => (
  <section className="SubscriptionHero">
    <div className="SubscriptionHero__card">
      <div
        className="SubscriptionHero__card-bg"
        aria-hidden="true"
        style={{
          '--hero-bg-desktop': `url(${heroBagsDesktop})`,
          '--hero-bg-mobile': `url(${heroBagsMobile})`,
        }}
      />
      <div className="SubscriptionHero__eyebrow">
        <span className="SubscriptionHero__eyebrow-icon">
          <img src={heroUnlimitedIcon} alt="" />
        </span>
        <span>Trashie Unlimited</span>
      </div>
      <h1 className="SubscriptionHero__title">
        <span>Clean out.</span>
        <span className="accent">Get cash back.</span>
        <span>Repeat.</span>
      </h1>
      <p className="SubscriptionHero__subtitle">
        Trashie Unlimited Membership gives you as many clean outs as you want, all year.
        Every clean out gets you TrashieCash. The more you clean out, the more cash back you unlock.
      </p>
    </div>
  </section>
);

export default SubscriptionHero;
